<template>
  <footer :class="{ traver_site_footer_a: isFixed, traver_site_footer_b: !isFixed }">
    <div class="website-record">
      Copyright © {{ year }} 南京速至所想旅游咨询有限公司 备案证书号：
      <a target="_blank"
         style="color: white"
         href="https://beian.miit.gov.cn/">
        苏ICP备20037515号
      </a>
      v 2.0.0
    </div>
  </footer>
</template>

<script>
export default {
  name: 'copy-right-and-web-infor',
  data() {
    return {
      year: '',
    }
  },
  props: {
    isFixed: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.getYear()
  },
  methods: {
    getYear() {
      this.year = new Date().getFullYear()
      // console.log(this.year);
    },
  },
}
</script>

<style>
.traver_site_footer_a {
  background-color: transparent;
  color: #000;
  min-height: 70px;
  bottom: 0;
  inset-inline-start: 0;
  padding: 0;
  /* position: fixed; */
  width: 100%;
  z-index: 100;
  align-items: center;
}

.traver_site_footer_b {
  background-color: transparent;
  min-height: 70px;
  bottom: 0;
  inset-inline-start: 0;
  padding: 0;
  position: fixed;
  width: 100%;
  z-index: 100;
  align-items: center;
}

.website-record {
  padding-top: 30px;
  display: flex;
  text-align: center;
  justify-content: center;
  color: white;
}
</style>